import { gql } from '@lcs/shared/api';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SaveBulkExtensionsMutation = gql`
   mutation SaveBulkExtensions($extensions: [ExtensionInput!]!) {
      extensions: saveExtensions(extensions: $extensions) {
         name
         number
         type
         accountId
         mailbox {
            emailAddress
         }
         extensionPhone {
            displayName
            ringTimeout
            defaultPhoneNumberId
            phonesConnection {
               items {
                  phoneType
                  numberOfLineKeys
                  devicesConnection {
                     items {
                        deviceId
                     }
                  }
               }
            }
         }
      }
   }
`;
